import React, { useState, useEffect } from 'react';
import { Collapse } from 'reactstrap';
//import { Link } from 'react-router-dom';
import NotificationsIcon from 'mdi-react/NotificationsIcon';
import { NotificationsAPI } from './api/NotificationsAPI';
import { Markup } from 'interweave';
import socketIOClient from "socket.io-client";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import AudioFileAdmision from '../AudioPanel/AudioFileAdmision';
import {
  getURLDataDiagnosticImagesToDoctor,
  getURLDataDiagnosticImagesAproveOrDeclineToTech
} from './URLSNotification';
import { getSearchClinicHistory } from '../ClinicHistory/SearchClinicHistory/components/DataFilterClinicHistory';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ENDPOINT = process.env.REACT_APP_PUBLIC_URL.toString().substring(0, process.env.REACT_APP_PUBLIC_URL.toString().length - 1);
const socket = socketIOClient(ENDPOINT, {
  autoConnect: false
});

let APINotifications = new NotificationsAPI();
const TopbarNotification = () => {

  let usuario = JSON.parse(sessionStorage.getItem('usuario'));

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const [lastNotification, setLastNotification] = useState(null);
  const [typeNotification, setTypeNotification] = useState(null);
  const [clickedNotification, setClickedNotification] = useState(null);
  const [tempDataPatient, setTempDataPatient] = useState(null);

  //Opciones
  const [audioModalOpen, setAudioModalOpen] = useState(false);

  const collapseNotification = () => {
    if (lastNotification != null && open == true) {
      setOpen(false);
      setLastNotification(null);
    }
    if (!isCollapsed) {
      setIsCollapsed(true);
    }
    else {
      setIsCollapsed(false);
    }
  };

  socket.open();
  socket.emit('userNotification', usuario.id_usuario);
  socket.on("getNotification", function (data) {
    let noti = notifications.filter(not => not.id_notificacion != data.id_notificacion);
    if (notifications.length >= 5) {
      noti.pop();
    }
    noti.splice(0, 0, data);
    setNotifications(noti);
    handleOpenNotificationNew(data);
  });

  const getNotifications = async () => {
    await APINotifications.listNotifications().then((res) => {
      setNotifications(res);
    }).catch((err) => {
      setNotifications([]);
    });
  }

  useEffect(() => {
    getNotifications();
  }, []);

  const mouseHoverNotification = async (notification) => {
    if (lastNotification != null && open == true) {
      setOpen(false);
      setLastNotification(null);
    }
    if (notification.vista == false) {
      let indexNot = notifications.indexOf(notification);
      let notificationsFiltered = notifications.filter(not => (not.id_notificacion != null));
      setNotifications(notificationsFiltered);
      await APINotifications.markNotification(notificationsFiltered[indexNot], true).then((res) => {
        notificationsFiltered[indexNot].vista = true;
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  const handleOpenNotificationNew = (notification) => {
    setLastNotification(notification);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    setLastNotification(null);
    setOpen(false);
  };

  const NotificationSnackbar = () => {
    return (<Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={open} autoHideDuration={8000} onClose={handleClose}>
      <Alert onClose={handleClose} severity="info">
        {lastNotification != null ? lastNotification.notificacion : null}
      </Alert>
    </Snackbar>)
  }

  const clickNotification = (notification) => {
    switch (notification.id_notificaciones_tipo) {
      case 1: //Transcripcion Enviada (Lo abre el DOCTOR)
        getSearchClinicHistory(notification).then((patient) => {
          openModalAudioNotification(notification);
          setTempDataPatient(patient[0]);
        }).catch((err) => {
          console.log(err);
        });
        break;
      case 2: //Transcripcion Aprobada o Rechazada
        getSearchClinicHistory(notification).then((patient) => {
          openModalAudioNotification(notification);
          setTempDataPatient(patient[0]);
        }).catch((err) => {
          console.log(err);
        });
        break;
      case 3: //Subida de Imagenes Diagnosticas
        getURLDataDiagnosticImagesToDoctor(notification);
        break;
      case 4: //Imagenes Diagnosticas aprobadas/rechazadas
        getURLDataDiagnosticImagesAproveOrDeclineToTech(notification);
        break;
      case 5: //Grabacion del Doctor para Transcripcion
        getSearchClinicHistory(notification).then((patient) => {
          openModalAudioNotification(notification);
          setTempDataPatient(patient[0]);
        }).catch((err) => {
          console.log(err);
        });
        break;
    }
    setIsCollapsed(false);
  }

  const closeModalAudioNotification = () => {
    setAudioModalOpen(false);
    setTypeNotification(null);
    setClickedNotification(null);
    setTempDataPatient(null);
  }

  const openModalAudioNotification = (notification) => {
    setAudioModalOpen(true);
    setTypeNotification(1);
    setClickedNotification(notification);
  }

  const AudioListHistory = () => {
    if (typeNotification == 1 && clickedNotification != null) {
      return (<AudioFileAdmision
        id_admision={clickedNotification.id_admision} 
        audioRecOpen={audioModalOpen} 
        closeAudioRec={() => {
          closeModalAudioNotification()
        }} 
        dataPatient={tempDataPatient}
        />);
    }
    else {
      return (<></>);
    }
  }

  return (
    <div className="topbar__collapse">
      <button className="topbar__btn topbar__btn--new" type="button" onClick={collapseNotification}>
        <NotificationsIcon />
        {
          notifications.some(not => not.vista == false) ? <div className="topbar__btn-new-label">
            <div />
          </div> : null
        }
      </button>
      {isCollapsed && (
        <button
          className="topbar__back"
          aria-label="topbar__back"
          type="button"
          onClick={collapseNotification}
        />
      )}
      <Collapse
        isOpen={isCollapsed}
        className="topbar__collapse-content"
      >
        <div className="topbar__collapse-title-wrap">
          <p className="topbar__collapse-title">Notificaciones</p>
        </div>
        {notifications.map(notification => (
          <div
            onClick={() => clickNotification(notification)}
            onMouseOver={() => mouseHoverNotification(notification)}
            className="topbar__collapse-item topbar__collapse-item-notification"
            key={notification.id_notificacion}>
            <Markup content={notification.html_notificacion} />
          </div>
        ))}
      </Collapse>
      <NotificationSnackbar />
      <AudioListHistory />
    </div>
  );
};

export default TopbarNotification;
